import * as React from 'react';
import { Input } from 'reactstrap';
import './job-list-filter.scss';

type JobListFilterProps = {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export default class JobListFilter extends React.PureComponent<JobListFilterProps> {
    public render() {
        const { value, onChange } = this.props;
        return (
            <div className="job-list-filter">
                <Input type="search" bsSize="sm" value={value} onChange={onChange} placeholder="Filter..." />
            </div>
        );
    }
}
